import { IXepHangTotNghiep } from "../../../model/response/category/IXepHangTotNghiep";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXepHangTotNghiepActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IXepHangTotNghiep[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IXepHangTotNghiep | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IXepHangTotNghiep,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

}

export const eXepHangTotNghiepActionIds = generateActionTypeIds(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP");
export type IXepHangTotNghiepActionTypes = IGenericActionType<typeof eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP">;